<ng-container *ngIf="licenceCountryBandData">
  <!-- DISPLAY UPGRADE MESSAGE IF SPECTRUM LIGHT -->
  <div class="SpectrumLight-alert" *ngIf="licenceCountryBandData.light">
    <div class="Alert Alert--basic">
      <h3>You need to <b>upgrade your subscription</b> to access all the data in this application.</h3>
    </div>
    <a routerLink='/upgrade/' class="Button Button--blue" (click)="analyticsService.pushUpgradeButtonClickEvent()"><span>Upgrade</span></a>
  </div>
  <div class="TableTitle TableTitle--inlineBlock TableTitle--withSwitch">
    <h2 class="Country">Country</h2>&nbsp;&nbsp;/&nbsp;&nbsp;<h2 class="Bands">Band</h2>
    <h1><a (click)="analyticsService.pushTitleClickEvent()" routerLink='/'>Licences</a> in <a (click)="analyticsService.pushTitleClickEvent()" [routerLink]="'/licences/country/'+licenceCountryBandData.countryCode">{{ ('CountryNames.' + licenceCountryBandData.countryCode) | translate }}</a> in the <a (click)="analyticsService.pushTitleClickEvent()" [routerLink]="'/licences/band/'+licenceCountryBandData.bandCode">{{ ('Band.' + licenceCountryBandData.bandCode) | translate }}</a> band</h1>
    <div class="Switch" (click)="toggleActiveMode()" [ngClass]="graphicMode ? 'Active' : ''" *ngIf="isGraphicDataAvailable()">
        <label for="on">
            <span data-title="Graphic"></span>
        </label>
    </div>
  </div>
  <div *ngIf="isTableMode()" class="TableMode" [class.Active]="isTableMode()">
    <table class="table ResponsiveTable ResponsiveTable--withHeaderMobile ResponsiveTable--CountryBand" *ngIf="licenceCountryBandData.licences.length > 0">
      <thead>
        <tr>
          <th scope="col">Licensee</th>
          <th scope="col">Scope</th>
          <th scope="col">MHz</th>
          <th scope="col">Award</th>
          <th scope="col">Duration</th>
          <th scope="col">Licence fee</th>
        </tr>
      </thead>
      <tbody *ngFor="let row of licenceCountryBandData.licences">
        <tr>
          <td data-th="Licensee" [class.EmptyCell]="hideLicensee(row)">
            <div *ngIf="row.licensee" class="NoWrap">{{ row.licensee }}</div>
            <!-- LIGHT CONTENT -->
            <div *ngIf="row.licenseeLegalName" [class.DisplayNone]="hideLegalName(row)" [innerHtml]="isSpectrumLightContent(row.licenseeLegalName)"></div>
            <!-- LIGHT COMMENT LOOKS LIKE CONTENT -->
            <div *ngIf="row.licenseeComment" class="RichText" [class.DisplayNone]="row.licenseeComment.length===1" [innerHtml]="isSpectrumLightContent(row.licenseeComment | forceTarget)"></div>
          </td>
          <td data-th="Scope" [class.EmptyCell]="hideScope(row)">
            <!-- LIGHT CONTENT -->
            <!-- <div *ngIf="row.geoScope" [innerHtml]="isSpectrumLightContent(row.geoScope)"></div> -->
            <div *ngIf="row.geoScope" [innerHtml]="row.geoScope"></div>
            <!-- LIGHT COMMENT -->
            <!-- <div *ngIf="row.geoScopeComment  && row.geoScopeComment != 'BLUR_COMMENT'" class="RichText" [class.DisplayNone]="row.geoScopeComment.length===1" [innerHtml]="row.geoScopeComment | forceTarget"></div> -->
            <div *ngIf="row.geoScopeComment" class="RichText" [class.DisplayNone]="row.geoScopeComment.length===1" [innerHtml]="row.geoScopeComment | forceTarget"></div>
          </td>
          <td data-th="MHz" class="NoWrap" [class.EmptyCell]="hideMHz(row)">
            <!-- LIGHT CONTENT -->
            <!-- <div *ngIf="row.bandwidth" [innerHtml]="isSpectrumLightContent(row.bandwidth)"></div> -->
            <div *ngIf="row.bandwidth" [innerHtml]="row.bandwidth"></div>
            <!-- LIGHT CONTENT -->
            <div *ngIf="row.mhzFromTo" [innerHtml]="isSpectrumLightContent(row.mhzFromTo)"></div>
            <!-- LIGHT COMMENT LOOKS LIKE CONTENT -->
            <div *ngIf="row.techNeutralLicenceComment" class="RichText" [innerHtml]="isSpectrumLightContent(row.techNeutralLicenceComment | forceTarget)" [class.DisplayNone]="row.techNeutralLicenceComment.length===1"></div>
          </td>
          <td data-th="Award" [class.EmptyCell]="hideAward(row)">
            <ng-container *ngIf="row.award">
              <a [routerLink]="'/awards/'+row.award.awardKey" *ngIf="row.award.awardKey">{{ row.award.awardKey | delete2FirstChar }}</a>
              <div *ngIf="row.award.status">{{ ('AwardType.' + row.award.type) | translate }}</div>
            </ng-container>
          </td>
          <td data-th="Duration" [class.EmptyCell]="hideDuration(row)">
            <!-- LIGHT CONTENT -->
            <div *ngIf="row.duration" [innerHtml]="isSpectrumLightContent(row.duration)"></div>
            <!-- LIGHT CONTENT -->
            <div *ngIf="row.beginDate">Begin: <span [innerHtml]="isSpectrumLightContent(row.beginDate)"></span></div>
             <!-- LIGHT COMMENT LOOKS LIKE CONTENT -->
            <div class="RichText" *ngIf="row.beginDateComment" [innerHtml]="isSpectrumLightContent(row.beginDateComment | forceTarget)" [class.DisplayNone]="row.beginDateComment.length===1"></div>
            <!-- LIGHT CONTENT -->
            <!-- <div *ngIf="row.endDate">Expiry: <span [innerHtml]="isSpectrumLightContent(row.endDate)"></span></div> -->
            <div *ngIf="row.endDate">Expiry: <span [innerHtml]="row.endDate"></span></div>
            <!-- LIGHT COMMENT -->
            <!-- <div class="RichText" *ngIf="row.endDateComment && row.endDateComment != 'BLUR_COMMENT'" [class.DisplayNone]="row.endDateComment.length===1" [innerHtml]="row.endDateComment | forceTarget"></div> -->
            <div class="RichText" *ngIf="row.endDateComment" [class.DisplayNone]="row.endDateComment.length===1" [innerHtml]="row.endDateComment | forceTarget"></div>
          </td>
          <ng-container *ngIf="currencyService.isEuro()">
            <td data-th="Licence fee" [class.EmptyCell]="hideLicenceFee(row)">
              <!-- LIGHT CONTENT -->
              <div *ngIf="row.fee && row.fee.priceEUR" [innerHtml]="isSpectrumLightContent(row.fee.priceEUR)"></div>
              <!-- LIGHT COMMENT WITH CONTENT LOOK -->
              <div class="RichText" *ngIf="row.feeComment" [innerHtml]="isSpectrumLightContent(row.feeComment) | forceTarget"></div>
            </td>
          </ng-container>
          <ng-container *ngIf="!currencyService.isEuro()">
            <td data-th="Licence fee" [class.EmptyCell]="hideLicenceFee(row)">
              <!-- LIGHT CONTENT -->
              <div *ngIf="row.fee && row.fee.priceUSD" [innerHtml]="isSpectrumLightContent(row.fee.priceUSD)"></div>
              <!-- LIGHT COMMENT WITH CONTENT LOOK -->
              <div class="RichText" *ngIf="row.feeComment" [innerHtml]="isSpectrumLightContent(row.feeComment) | forceTarget" [class.DisplayNone]="row.feeComment.length===1"></div>
            </td>
          </ng-container>
          <!-- LIGHT COMMENT -->
          <td data-th="Comment" class="Comment Comment--cell" *ngIf="row.comment && row.comment  != 'BLUR_COMMENT'" [class.EmptyCell]="row.comment" [class.DisplayNone]="!row.comment">
            <div class="RichText" [innerHtml]="row.comment | forceTarget" *ngIf="row.comment  != 'BLUR_COMMENT'"></div>
          </td>
        </tr>
        <!-- LIGHT COMMENT LOOKS LIKE CONTENT -->
        <tr class="Comment Comment--row" *ngIf="row.comment" [class.DisplayNone]="row.comment.length===0">
          <td colspan="6">
            <table class="BasicResponsiveTable">
              <tbody>
                <tr>
                  <td data-th="List of operators">
                    <span class="RichText" [innerHtml]="isSpectrumLightContent(row.comment | forceTarget)"></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="table ResponsiveTable" *ngIf="licenceCountryBandData.comments.length" [class.DisplayNone]="licenceCountryBandData.comments.length===0">
      <thead>
        <tr>
          <th>Comment</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td data-th="Comment">
            <div *ngFor="let comment of licenceCountryBandData.comments" class="RichText" [innerHtml]="comment | forceTarget"></div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="NoResult" *ngIf="licenceCountryBandData.licences.length===0 && !licenceCountryBandData.light">
      <p>No licence registered in the database</p>
    </div>
    <div class="NoResult" *ngIf="licenceCountryBandData.licences.length===0 && licenceCountryBandData.light">
      <p>No licence registered in the database or Upgrade your subscription</p>
    </div>
  </div>
  <div *ngIf="isGraphicMode()" class="GraphicMode" [class.Active]="isGraphicMode()">
    <div class="FrequencyDistribution" *ngIf="licenceCountryBandData.frequencyDistribution.ranges.length > 0">
      <div class="FrequencyDistribution-container">
        <div *ngFor="let frequency of licenceCountryBandData.frequencyDistribution.ranges" class="Frequency-container" [ngClass]="frequency.duplexModeWay" [class.Frequency-container--small]="frequency.small" [ngStyle]="{'-ms-flex-preferred-size': frequency.percent+'%', 'flex-basis': frequency.percent+'%'}">
          <p class="Start">{{ frequency.start }}</p>
          <p class="End">{{ frequency.end }}</p>
          <div class="Frequency">
            <div class="Block-container">
              <div *ngFor="let block of frequency.licences"  class="Block" [ngClass]="block.classification" [ngStyle]="{'-ms-flex-preferred-size': block.percent+'%', 'flex-basis': block.percent+'%'}">
                <h4>{{block.size}}</h4>
              </div>
            </div>
          </div>
          <h3 class="Title">{{ ('Frequency.' + frequency.duplexModeWay) | translate }}</h3>
        </div>
      </div>
      <ul class="Legend">
        <li *ngFor="let operator of licenceCountryBandData.frequencyDistribution.legend.classification | keyvalue">
          <span [ngClass]="operator.key"></span>
          <p>{{operator.value}}</p>
          {{operator.allGroupedNames}}
          <!-- <sup *ngIf="operator.value==='Regional licences'">*</sup> -->
          <sup *ngIf="showAsterisk(operator, licenceCountryBandData.frequencyDistribution.legend.allGroupedNames)">*</sup>
        </li>
        <legend *ngIf="licenceCountryBandData.frequencyDistribution.legend.allGroupedNames">* {{ licenceCountryBandData.frequencyDistribution.legend.allGroupedNames }}</legend>
      </ul>
    </div>
    <div class="FrequencyDistribution FrequencyDistribution--notAvailable" *ngIf="licenceCountryBandData.frequencyDistribution.ranges.length===0 && !licenceCountryBandData.frequencyDistribution.light">
      <p class="Start">{{ licenceCountryBandData.frequencyDistribution.noGraphFallback.start }}</p>
      <p class="End">{{ licenceCountryBandData.frequencyDistribution.noGraphFallback.end }}</p>
      <div class="FrequencyDistribution-container">
        <p *ngIf="licenceCountryBandData.frequencyDistribution.noGraphFallback.percent === 0">
          <b *ngIf="licenceCountryBandData.frequencyDistribution.noGraphFallback.nationalRegionalCount.regional">Regional licences -</b>
          <b *ngIf="licenceCountryBandData.frequencyDistribution.noGraphFallback.nationalRegionalCount.local">Local licences -</b>
          &nbsp;The exact location of the licences within the band is not available yet.
        </p>
        <p *ngIf="licenceCountryBandData.frequencyDistribution.noGraphFallback.percent > 0"><b>{{ licenceCountryBandData.frequencyDistribution.noGraphFallback.percent }}% <span *ngIf="licenceCountryBandData.frequencyDistribution.noGraphFallback.mhzTotalSize!=0">({{ licenceCountryBandData.frequencyDistribution.noGraphFallback.mhzTotalSize }} MHz) </span>awarded</b> - The exact location of the licences within the band is not available yet.</p>
        <span class="Progress" [style.width]="licenceCountryBandData.frequencyDistribution.noGraphFallback.percent+'%'"></span>
      </div>
      <ul class="Legend Legend--noGraphFallback">
        <li *ngFor="let operator of licenceCountryBandData.frequencyDistribution.noGraphFallback.operators">
          <span></span>
          <p>{{operator}}</p>
          <!-- <sup *ngIf="operator.value==='Regional licences'">*</sup> -->
          <sup *ngIf="showAsterisk(operator, licenceCountryBandData.frequencyDistribution.legend.allGroupedNames)">*</sup>
        </li>
        <legend *ngIf="licenceCountryBandData.frequencyDistribution.legend.allGroupedNames">* {{ licenceCountryBandData.frequencyDistribution.legend.allGroupedNames }}</legend>
      </ul>
    </div>
    <div class="NoResult NoResult--spectrumLight" *ngIf="licenceCountryBandData.frequencyDistribution.ranges.length===0 && licenceCountryBandData.frequencyDistribution.light">
      <p>You need to <b>upgrade your subscription</b> to see this graphic</p>
    </div>
  </div>
</ng-container>
